import React from 'react';
import PropTypes from 'prop-types';
import Row from 'components/Row';
import Col from 'components/Col';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {getSuggestedProducts} from 'api/suggestedProduct';
import EditableCheckbox from 'components/forms/editableCheckbox';
import classNames from 'classnames';
import LoadingBtn from 'components/loadingBtn';
import {getProducts, getNaturalChemistryProducts} from 'helpers/suggestedProductList';
import {suggestedProductsEnabled} from 'features';
import {countries} from 'helpers/constants';

const cbtToProductCategory = new Map();

cbtToProductCategory.set(1, 'halogenPool');
cbtToProductCategory.set(2, 'halogenPool');
cbtToProductCategory.set(3, 'biguanidePool');
cbtToProductCategory.set(5, 'halogenSpa');
cbtToProductCategory.set(6, 'halogenSpa');
cbtToProductCategory.set(7, 'mineralSpringsPool');
cbtToProductCategory.set(8, 'biguanideSpa');
cbtToProductCategory.set(12, 'saltPool');
cbtToProductCategory.set(13, 'saltSpa');
cbtToProductCategory.set(14, 'halogenPool');
cbtToProductCategory.set(15, 'halogenSpa');

class SuggestedProductsSelection extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    branch: PropTypes.object.isRequired,
    chemicalBaseTypeID: PropTypes.number.isRequired,
    dealer: PropTypes.object.isRequired,
    saving: PropTypes.bool,
    isValidating: PropTypes.bool,
    analysis: PropTypes.object,
    isScanning: PropTypes.bool,
    saveAnalysis: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    let selected = {};

    const naturalChemistyEnabled =  props && !!props.branch && !!props.branch.naturalChemistry;

    if (props && props.analysis && props.analysis.suggestedProducts && props.analysis.suggestedProducts.length) {
      let sp = props.analysis.suggestedProducts;

      if(!naturalChemistyEnabled) {
        let {country} = props.dealer;
        const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);

        sp = (sp || []).filter(p => !ncProducts.includes(p));
      }

      selected = sp.reduce((acc, x) => {
        acc[x] = true;
        return acc;
      }, selected);
    }

    this.state = {
      suggestedProducts: [],
      selected,
    };
  }

  componentWillMount() {
    const {branch, dealer} = this.props;

    getSuggestedProducts()
      .then(sp => {
        const naturalChemistyEnabled =  !!branch && !!branch.naturalChemistry;

        if(!naturalChemistyEnabled) {
          let {country} = dealer;
          const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);

          sp = (sp || []).filter(p => !ncProducts.includes(p.product));
        }

        this.setState({
          suggestedProducts: sp || [],
        });
      })
      .catch(err => {
        // TODO: write better message here
        console.error(err);
      });
  }

  componentWillReceiveProps(nextProps) {
    if (Object.keys(this.state.selected).length ||
      !(nextProps.analysis !== this.props.analysis && nextProps.analysis.suggestedProducts !== this.props.analysis.suggestedProducts &&
        nextProps.analysis.suggestedProducts && this.props.analysis.suggestedProducts &&
        nextProps.analysis.suggestedProducts.length !== this.props.analysis.suggestedProducts.length)) {
      return;
    }

    const naturalChemistyEnabled =  this.props && !!this.props.branch && !!this.props.branch.naturalChemistry;
    let sp = nextProps.analysis.suggestedProducts;

    if(!naturalChemistyEnabled) {
      let {country} = this.props.dealer;
      const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);

      sp = (sp || []).filter(p => !ncProducts.includes(p));
    }

    const selected = sp.reduce((acc, x) => {
      acc[x] = true;
      return acc;
    }, {});

    this.setState({selected});
  }

  select = (product, enabled) => {
    const selected = this.state.selected;

    selected[product.product] = enabled;

    this.setState({selected});
  };

  render() {
    const {chemicalBaseTypeID, dealer, branch} = this.props;
    const {formatMessage} = this.props.intl;
    const naturalChemistyEnabled =  !!branch && !!branch.naturalChemistry;

    const products = getProducts(dealer.country, chemicalBaseTypeID, false, naturalChemistyEnabled);

    let visible = true;

    const options = products ?
      this.state.suggestedProducts
        .filter(x => x.productCategory === cbtToProductCategory.get(chemicalBaseTypeID) &&
          products.map(y => y.id).includes(x.product)) :
      null;

    if (!products || !options || !options.length || !suggestedProductsEnabled) {
      visible = false;
    }

    const currentlySelected = Object.keys(this.state.selected)
      .filter(x => this.state.selected[x])
      .map(x => this.state.suggestedProducts.find(y => y.product === parseInt(x)))
      .filter(sp => !!sp);

    return <Row>
      <Col xs={12}>
        {visible ? <h2>
          <FormattedMessage id="general.suggested-products"/>
          <ToolTip title={formatMessage({id: 'suggested-products.analysis.tooltip'})}
                   position={tooltipPositions.topRight}
                   iconOnly/>
        </h2> : null}

        {visible ? <div className='analysis-body'>
          <Row>
            <Col xs={12}>
              <p className='suggested-products__instructions'>
                <FormattedMessage id="suggested-products.analysis.instructions"/></p>
            </Col>
          </Row>
          <div className='suggested-products'>
            {options.map(x => <ProductCard key={x.id}
                                           product={x}
                                           productsList={products}
                                           defaultValue={this.state.selected[x.product]}
                                           onSelect={this.select}
                                           enabled={Object.values(this.state.selected).filter(x => !!x).length < 2}
                                           country={dealer.country}/>)}
          </div>
        </div> : null}
        <div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-12'>
                <LoadingBtn className='btn btn-primary pull-right'
                            loading={this.props.saving}
                            onClick={() => this.props.saveAnalysis(undefined, currentlySelected)}
                            disabled={this.props.isScanning || this.props.saving || this.props.isValidating}>
                  <FormattedMessage id="general.analyze"/>
                </LoadingBtn>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>;
  }
}

class ProductCard extends React.Component {
  static propTypes = {
    country: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    productsList: PropTypes.array.isRequired,
    defaultValue: PropTypes.bool,
    enabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);


    this.state = {
      selected: props.defaultValue || false,
    };
  }

  componentDidMount() {
    if (this.inner) {
      this.inner.addEventListener('click', this.clickHandler);
    }
  }

  componentWillUnmount() {
    if (this.inner) {
      this.inner.removeEventListener('click', this.clickHandler);
    }
  }

  clickHandler = () => {
    if (!this.props.enabled && !this.state.selected) {
      return;
    }

    this.setState(prevState => ({selected: !prevState.selected}),
      () => {
        this.props.onSelect(this.props.product, this.state.selected);
      });
  };

  addDefaultImageSrc = (e) => {
    e.target.src = '/Content/img/suggested-products/fallback.svg';
  }

  render() {
    const {product, productsList, country, enabled} = this.props;
    const fullProduct = productsList.find(x => x.id === product.product);

    return <div
      ref={r => this.inner = r}
      className={classNames('suggested-products__product', {
        'suggested-products__product--active': this.state.selected,
      })}>
      <EditableCheckbox editMode={true}
                        onChange={() => {
                        }}
                        disabled={!enabled && !this.state.selected}
                        value={this.state.selected}/>
      <label>{fullProduct.name}</label>
      <div className='suggested-products__container'>
        <img src={fullProduct.tag ? `/Content/img/suggested-products/${country}/${fullProduct.tag}.png` : '/Content/img/suggested-products/fallback.svg'}
            className='suggested-products__image'
            onError={this.addDefaultImageSrc}
            alt={fullProduct.name}/>
        </div>
    </div>;
  }
}

export default injectIntl(SuggestedProductsSelection);
